<template>
  <BaseLayout
    v-bind="$attrs"
    v-on="$listeners"
    :disableFooter="true"
    :styleConfig="styleConfig"
  >
    <template v-slot:header>
      <TheHeaderMinimal :requireAuth="true" />
    </template>
    <template v-slot:container>
      <slot />
    </template>
  </BaseLayout>
</template>

<script>
  import BaseLayout from '@base/v2/base-layout'
  import TheHeaderMinimal from '@modules/v2/layout/the-header-minimal'
  import { Z_INDEXES } from '@js/constants'

  export default {
    name: 'LayoutMinimal',
    inheritAttrs: false,
    components: {
      BaseLayout,
      TheHeaderMinimal,
    },
    data: function () {
      return {
        styleConfig: {
          container: {
            alignItems: 'center',
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'flex-start',
            width: '100%',
          },
          footer: {},
          header: {
            alignItems: 'center',
            display: 'flex',
            height: '64px',
            justifyContent: 'center',
            width: '100%',
            zIndex: Z_INDEXES.LAYOUT.HEADER,
          },
          root: {},
        },
      };
    },
  };
</script>
